<script lang="ts">
import Pagination from 'objects/pagination/Pagination.vue'
import trackingService from '../services/tracking-service'

/**
 * NOTE: It is EXPECTED that a component using this mixin has a "fetchData" method that makes a
 * call to update the data based on currentPage or query parameters changing. It is RECOMMENDED
 * that the "fetchData" method uses debounce for cases where more than one thing can trigger a
 * query change.
 * Components using this mixin can optionally include "sortBy" and/or "filtersQueryString"
 * properties that will be watched for to trigger a "fetchData" call.
 */
export default {
  components: {
    'tt-pagination': Pagination
  },
  data() {
    return {
      initialPageSize: 10, // to be set in implementing component
      isLoading: false,
      loadError: null,
      pageSize: 20, // to be set in implementing component
      currentPage: 1,
      total: 0,
      offset: 0
    }
  },
  computed: {
    hasMore() {
      if (this.offset === 0) {
        return this.initialPageSize < this.total
      }
      return this.offset + this.pageSize < this.total
    }
  },
  methods: {
    onQueryChange() {
      this.offset = 0
      this.currentPage = 1
      this.fetchData()
    },
    pageChange(pageNum, type) {
      if (type === 'reviews-list') {
        this.queueReviewsPageWebEvent(pageNum, type)
      } else if (type === 'qa') {
        this.queueQaPageWebEvent(pageNum, type)
      }

      if (pageNum === 1) {
        this.offset = 0
      } else {
        this.offset = this.initialPageSize + ((pageNum - 2) * this.pageSize)
      }
      this.currentPage = pageNum
      this.fetchData(true)
    },
    showMore(type) {
      if (type === 'reviews-list') {
        this.queueReviewsPageWebEvent('more', type)
      } else if (type === 'qa') {
        this.queueQaPageWebEvent('more', type)
      }
      // this is used when a "show more" button is being used instead of normal pagination
      this.offset = this.offset === 0 ? this.initialPageSize : (this.offset + this.pageSize)
      this.fetchData()
    },
    queueReviewsPageWebEvent(pageNumber, widget) {
      const filters = this.reviewsStore.filterStore.appliedFilters
      const eventProperties = {
        nr: this.initialPageSize,
        f: filters,
        st: this.sortBy,
        s: this.searchTerm,
        p: pageNumber
      }
      trackingService.queueEvent(widget, 'page', this.currentSku, eventProperties)
    },
    queueQaPageWebEvent(pageNumber, widget) {
      const eventProperties = {
        nr: this.initialPageSize,
        st: this.sortBy,
        s: this.searchTerm,
        p: pageNumber
      }
      trackingService.queueEvent(widget, 'page', this.currentSku, eventProperties)
    }
  },
  watch: {
    sortBy(newValue, oldValue) {
      if (oldValue !== '') {
        this.onQueryChange()
      }
    },
    filtersQueryString() { this.onQueryChange() }
  }
}
</script>
